<template>
    <v-hover v-slot="{ hover }">
      <v-card
          class="ma-4 pa-1"
          :width=" width? width: 340"
          :elevation="hover ? 12 : 2"
          :color="(type=='Danger')? color:'#FFFFFF'"
          v-on:click="clicking(value)"
      >
          <v-list-item>
          <v-row
            justify="end"
          >
          <v-list-item-content 
          >
            <v-card-title :class="(type=='Danger') ? 'white--text':''" class="card-title ml-4 pa-0" v-if="(value!=undefined) && value.length<10 && !cardType"> {{value.charAt(0).toUpperCase() + value.slice(1)}} </v-card-title>
            <v-card-text :class="(type=='Danger') ? 'white--text':''" style="font-size: 16px;font-weight: 500;"  class="ml-4 mb-4 pa-0" v-else> {{value.charAt(0).toUpperCase() + value.slice(1)}} </v-card-text>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-card-text
                  v-bind="attrs"
                  v-on="on"
                  :class="(type=='Danger') ? 'white--text py-0':'py-0'"
                >{{ title | translate }} </v-card-text>
              </template>
              <span>{{ description| translate }} </span>
            </v-tooltip>
  
                <v-list
                  subheader
                  two-line
                  :color="(type=='Danger')? '#FFFFFF':'#FFFFFF'"
                  v-if="details && hover ? details.length ? true:false:false "
                >
                  <v-list-item class="ml-2" :class="(type=='Danger') ? 'white--text':''" v-for="(carddetails,index) in details" :key="index">
                      <v-list-item-content>
                          <v-list-item-subtitle :class="(type=='Danger') ? 'black--text':''"> <v-icon color="grey">mdi-file-document </v-icon> {{carddetails.item_name}}</v-list-item-subtitle>
                          <v-list-item-subtitle :class="(type=='Danger') ? 'black--text':''"> <v-icon color="grey">mdi-file-document-edit </v-icon> {{carddetails.temp_name}}</v-list-item-subtitle>
                          <v-list-item-subtitle :class="(type=='Danger') ? 'black--text':''"> <v-icon color="grey">mdi-calendar-alert </v-icon> <b>{{carddetails.day_until}}</b> <span class="font-weight-light" >{{'days overdue'| translate}} </span></v-list-item-subtitle>
                      </v-list-item-content>
                   </v-list-item>
                  <v-btn small class="ml-6 white--text" :color="color" :to="'/inbox'" >{{ 'Jump to Inbox'| translate }}</v-btn>
                </v-list>
          </v-list-item-content>
  
            <v-icon class="card-image" :color="color"  v-if="type=='LastLoggedIn'"> mdi-calendar </v-icon>
            <v-icon class="card-image" :color="color"  v-if="type=='Subscriptions'"> mdi-file-check </v-icon>
            <v-icon class="card-image" :color="color"  v-if="type=='BreachedDocuments'"> mdi-exclamation-thick </v-icon>
            <v-icon class="card-image" :color="color"  v-if="type=='Calendars'"> mdi-calendar </v-icon>
            <v-icon class="card-image" :color="color"  v-if="type=='TimeSpent'"> mdi-clock </v-icon>
            
            <v-icon class="card-image" :color="color"  v-if="!type">mdi-dark mdi-inactive mdi-dark mdi-check </v-icon>
          </v-row>
        </v-list-item>
  
      </v-card>
    </v-hover>
  </template>
  
  <script>
  export default {
    name: 'DashCard',
    props: {
        width:Number,
        cardType: Boolean,
        type: String,
        title: String,
        description: String,
        value: String,
        color: String,
        details: Array,
    },
    methods: {
      clicking(data) {
        this.$emit("clicking",data)
      },
    }
  }
  </script>
  
  <style scoped>
  .card-title{
      font-size: 30px;
  }
  .card-image{
      font-size: 60px;
  }
  </style>